//////////////////
// IMPORTS
//////////////////
// libraries
import * as React from "react";
// week-in-review-snapshot imports
import { IProps } from "./WeekInReviewSnapshot.d";
import * as s from "./WeekInReviewSnapshot.styles";
// util
import { SlotCategory } from "@util/rewind-history.util";

export interface IDayProps {
  dayOfSlots: SlotCategory[];
  dayIndex: number;
}

//////////////////
// UTIL
//////////////////
// controls what color a block is
function getSlotColor(slotType: SlotCategory) {
  switch (slotType) {
    case SlotCategory.Focus:
      return s.time.focus;
    case SlotCategory.Hold:
    case SlotCategory.Lunch:
      return s.time.other;
    case SlotCategory.Meeting:
      return s.time.busy;
    case SlotCategory.Fragmented:
    case SlotCategory.Unassigned:
      return s.time.unassigned;
    case SlotCategory.AfterHours:
    default:
      return "transparent";
  }
}

const HeaderLabels = ["M", "T", "W", "T", "F"];

//////////////////
// SUB-COMPONENTS
//////////////////
const DayInReview = ({ dayOfSlots, dayIndex }: IDayProps) => {
  const blocks = dayOfSlots.map((slot, i) => {
    const blockKey = `day${dayIndex}_block${i}`;
    const style: React.CSSProperties = {
      ...s.slot,
      backgroundColor: getSlotColor(slot),
    };
    return <div style={style} key={blockKey} />;
  });
  return <div style={s.dayContainer}>{blocks}</div>;
};

//////////////////
// COMPONENT
//////////////////
export class WeekInReviewSnapshot extends React.Component<IProps> {
  constructor(props: IProps) {
    super(props);
  }

  public render() {
    const labels = HeaderLabels.map((label, i) => (
      <div style={s.label} key={`label${i}`}>
        {label}
      </div>
    ));

    const days = this.props.weekOfSlots.map((dayOfSlots, dayIndex) => (
      <DayInReview dayOfSlots={dayOfSlots} dayIndex={dayIndex} key={`day_${dayIndex}`} />
    ));

    return (
      <div style={s.snapshotContainer}>
        {labels}
        {days}
      </div>
    );
  }
}
